// PDF出力設定制御
export const controlPdfSettingConstraint = (oldPdfSetting, shippingDateIsInterval, asSendingLabel) => {
  let newPdfSetting = {...oldPdfSetting};

  if(!shippingDateIsInterval) {
    newPdfSetting.datePartition = false;
  }
  if (newPdfSetting.isUsingSellingPrice) {
    newPdfSetting.columnNumber = '1';
    newPdfSetting.general = '2';
  }
  if (
    (newPdfSetting.direction == '1' && newPdfSetting.columnNumber == '2')
      || (newPdfSetting.direction == '2' && newPdfSetting.columnNumber == '3')
  ) {
    newPdfSetting.shopSummary = '1';
  }
  if (newPdfSetting.columnNumber !== '1') {
    newPdfSetting.datePartition = false;
  }
  if (newPdfSetting.datePartition) {
    newPdfSetting.shopSummary = '1';
  }
  if (newPdfSetting.directorEmployeePartition == true) {
    newPdfSetting.directorEmployeePartition = "1";
  }

  if (asSendingLabel) {
    newPdfSetting.shopSummary = '1';
    newPdfSetting.outputPrice = false;
    newPdfSetting.skipNoOrder = true;
    newPdfSetting.datePartition = false;
    newPdfSetting.directorEmployeePartition = "2";
    newPdfSetting.asSendingLabel = true;
  }
  
  return newPdfSetting;
}
